import { render, staticRenderFns } from "./CrudContactPerson.vue?vue&type=template&id=a4e122be&scoped=true"
import script from "./CrudContactPerson.vue?vue&type=script&lang=js"
export * from "./CrudContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e122be",
  null
  
)

export default component.exports